import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { API } from "../../../app.config";
import { Observable } from "rxjs";
import { BuscaHotelRQ, Cidade, ListaPaginada, Pacote, PacoteReserva } from "../../../model";

@Injectable({
    providedIn: "root",
})
export class PacoteRodoviarioService {
    constructor(private http: HttpClient) {}

    buscarEstatico(busca: BuscaHotelRQ): Observable<PacoteReserva> {
        return this.http.post<PacoteReserva>(`${API}/api/pacoterodoviario/buscapacoterodoviario/`, busca);
    }

    buscaPacotesRodoviariosDestino(destinoId: number, pagina: number): Observable<ListaPaginada<Pacote>> {
        return this.http.get<ListaPaginada<Pacote>>(
            `${API}/api/pacotes/listapaginadarodoviario/${destinoId}?Pagina=${pagina}&ItensPorPagina=12`
        );
    }

    buscarOrigem(tarifarioId: number): Observable<Cidade[]> {
        return this.http.get<Cidade[]>(`${API}/api/pacoterodoviario/origens/${tarifarioId}`);
    }

    vincular(pacoteId: number, tarifarioRodoviarioId: number): Observable<void> {
        return this.http.post<void>(
            `${API}/api/pacote-tarifariorodoviario/vincular/${pacoteId}/${tarifarioRodoviarioId}`,
            {}
        );
    }

    desvincular(pacoteId: number, tarifarioRodoviarioId: number): Observable<void> {
        return this.http.delete<void>(
            `${API}/api/pacote-tarifariorodoviario/desvincular/${pacoteId}/${tarifarioRodoviarioId}`,
            {}
        );
    }
}
